import React from 'react';
// Mui
import {
  InputAdornment,
  TextField, TextFieldProps
} from '@mui/material';
// Icons
import {
  VisibilityOff as VisibilityOffIcon,
  Visibility as VisibilityIcon,
  Clear as ClearIcon
} from '@mui/icons-material';
// Components
import { IconButton } from 'app/components/Mui';
// Hooks
import useToggle from 'app/hooks/useToggle';
// Utilities
import { generateAttrForTesting } from 'app/utilities/Utilities';

const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

type InputProps = TextFieldProps & {
  onClear?: () => void;
};

const Input = React.forwardRef<any, InputProps>(({ onClear, ...restProps }, ref) => {
  const { open, toggle } = useToggle();

  const slotProps:TextFieldProps['slotProps'] = {
    input: {
      ...restProps.slotProps?.input,
      ...generateAttrForTesting('control', 'input', restProps.name)
    },
  };

  if ( restProps.type === 'password' ){
    slotProps['input'] = {
      ...slotProps['input'],
      type: open ? 'text' : 'password',
      autoComplete: restProps.autoComplete
        ? restProps.type === 'password'
          ? isChrome ? 'new-password' : restProps.autoComplete
          : restProps.autoComplete
        : ''
      ,
      endAdornment: (
        <InputAdornment position="end">
          <IconButton
            sx={{ mr: 1 }}
            name="Toggle password"
            onClick={toggle}
            edge="end"
            aria-label={open ? 'Hide password' : 'Show password'}
          >{open ? <VisibilityOffIcon /> : <VisibilityIcon />}</IconButton>
        </InputAdornment>
      )
    }
  }
  if ( onClear ) {
    slotProps['input'] = {
      ...slotProps['input'],
      endAdornment: restProps.value ? (
        <InputAdornment position="end">
          <IconButton
            name="Clear"
            aria-label="Clear"
            onClick={onClear}
            size="small"
          ><ClearIcon fontSize="small" /></IconButton>
        </InputAdornment>
      ) : null
    }
  }
  if ( restProps.disabled ) {
    slotProps['inputLabel'] = {
      ...slotProps['inputLabel'],
      shrink: true,
    }
  }

  return (
    <TextField
      {...restProps}
      ref={ref}
      slotProps={slotProps}
    />
  );
});

export default Input;
